import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "./item.module.css";
import styles1 from "../Category/category.module.css";
import { CiSearch } from "react-icons/ci";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import { RiArrowDropDownFill } from "react-icons/ri";
import MenuApi from "../../../App/api/menu.apis";
import "react-lazy-load-image-component/src/effects/blur.css";
import ProductsCard from "./ProductsCard";
import { useNavigate, useParams } from "react-router";
import debounce from "lodash.debounce";
import { getAllCategory } from "../Category/HelperCategory";
import FoodCard from "./FoodCard";
import

{ useFetchAll } from "../../../custom/FetchApiHook";

const Item = ({meta}) => {
  const { value: allBusinessTypeData } = useFetchAll(() => MenuApi.getAllBusinesgetsType());
  const searchRef = useRef();
  const [changeStore, setChangeStore] = useState(false);
  const [subCategory, setSubCategory] = useState(false);
  const [allItemProduct, setAllItemProduct] = useState(null);
  const [hasMore, setHasMore] = useState(0);
  const [itemDetails, setItemDetails] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [venderData, setVenderData] = useState(null);
  const [businessType, setBusinessType] = useState('Ecommerce');
  const [venderId, setVenderId] = useState(null);
  const [searchItem, setSearchItem] = useState("");
  const [searchShowHide, setSearShowHide] = useState({
    show: false,
    value: "Descending",
  });

  const navigate = useNavigate();
// console.log("allBusinessTypeData:",allBusinessTypeData);


  let { id } = useParams();
  const [objectId, heading] = id ? id.split("-") : [null, null];

  const fetchAllData = async (asc) => {
    let filter;
    if (objectId) {
      filter = {
        sub_category: objectId,
        status: "Approved",
      };
    } else {
      filter = { status: "Approved" };
    }

    setPageNumber(1);
    setAllItemProduct(null);
    const res = await getAllCategory(() =>{
      
      if (businessType==="Ecommerce") {
      const response=  MenuApi.item.getAllItemProduct({
          filter: filter,
          page: 1,
          limit: 6,
          sortOrder: asc,
        })
        return response
      }
      else{
        const response=  MenuApi.item.getAllFoodItemProduct({
          filter: filter,
          page: 1,
          limit: 6,
          sortOrder: asc,
        })
        return response
      }
    });
    // console.log("res", res);
    setHasMore(res?.data?.totalCount);
    setAllItemProduct(res?.data?.products);
    setPageNumber(2);
  };

  const handleLoadMore = async () => {
    let filter;
    if (objectId) {
      filter = {
        sub_category: objectId,
        status: "Approved",
      };
    } else if (venderId) {
      filter = {
        created_by: venderId?.filter?.created_by,
        status: "Approved",
      };
      // console.log("filter", filter);
    } else {
      filter = {
        status: "Approved",
      };
    }

    const res = await getAllCategory(() =>
      {  
       if (businessType==='Ecommerce') {
         const response= MenuApi.item.getAllItemProduct( {
          filter,
          page: pageNumber,
          limit: 6,
        },
        searchItem)          
         return response
       }
       else{
         const response=  MenuApi.item.getAllFoodItemProduct(  {
          filter,
          page: pageNumber,
          limit: 6,
        },
        searchItem)
         return response
       }
       }
       );
   
    // console.log("res", res);
    setHasMore(res?.data?.totalCount);
    const newData = res?.data?.products;
    setPageNumber(pageNumber + 1);
    setAllItemProduct((prev) =>
      pageNumber === 1 ? newData : [...prev, ...newData]
    );
  };

  const getItemSearch = async (query) => {
    let filter;
    if (venderId) {
      filter = venderId?.filter;
    } else if (objectId) {
      filter = {
        sub_category: objectId,
        status: "Approved",
      };
    } else
      filter = {
        status: "Approved",
      };
    try {
      const res = await getAllCategory(() =>
     {  
      console.log('businessType',businessType);
      
      if (businessType==='Ecommerce') {
        const response= MenuApi.item.getAllItemProduct({ filter: filter, page: 1, limit: 6 }, query)          
        return response
      }
      else{
        const response=  MenuApi.item.getAllFoodItemProduct( { filter: filter, page: 1, limit: 6 },query)
        return response
      }
      }
      );
      setHasMore(res?.data?.totalCount);
      const newData = res?.data?.products;
      setAllItemProduct(newData);
      setPageNumber(2);
    } catch (error) {
      // console.log("error", error);
    }
  };
  const getVenderItem = async (vender_id, data) => {

    console.log('vender_id',vender_id);
    console.log('data',data);
    setVenderData(data);
    setVenderId(vender_id);
    try {
      const res = await getAllCategory(() =>{
         if (data?.delivery_business?.name===businessType) {
        const response=  MenuApi.item.getAllFoodItemProduct({
            filter: {
              created_by: vender_id?.filter?.created_by,
              status: "Approved",
            },
            page: 1,
            limit: 6,
          })
          return response
         } else {
          const response= MenuApi.item.getAllItemProduct({
             filter: {
               created_by: vender_id?.filter?.created_by,
               status: "Approved",
             },
             page: 1,
             limit: 6,
           })
           return response
        }      
         
       
      });
      setHasMore(res?.data?.totalCount);
      const newData = res?.data?.products;
      setAllItemProduct(newData);
      setPageNumber(2);
      navigate("/app/menu/item/");
      id = null;
    } catch (error) {
      // console.log("error", error);
    }
  };
  useEffect(() => {
    fetchAllData();
  }, [businessType]);

  const hideOutsideClick = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setSearShowHide({
        value: searchShowHide.value,
        show: false,
      });
    }
  };
  const handleAllProductClicked = async (item) => {
    setItemDetails(item);
    try {
      // const res = await MenuApi.item.getProductById(item?._id);
      // // console.log("res", res?.data?.data?.product_varient);
      businessType==="Ecommerce"? navigate(`/app/product-details/${item?._id}`):navigate(`/app/food-product-details/${item?._id}`)
    } catch (error) {
      // console.log("error", error);
    }
    setSubCategory(true);
  };

  // const handleVariantSelected = (product) => {
  //   // console.log("product", product);
  //   setItemDetails(product);
  // };

  const toggleSearch = (val) => {
    setSearShowHide({
      value: searchShowHide.value,
      show: val,
    });
  };

  const debouncedFetch = useCallback(
    debounce((query) => getItemSearch(query), 1000),
    [venderId,businessType]
  );

  const handleItemSearchChange = (event) => {
    const query = event.target.value;
    setSearchItem(query);
    debouncedFetch(query);
  };
  useEffect(() => {
    document.addEventListener("mousedown", hideOutsideClick);

    return () => {
      document.removeEventListener("mousedown", hideOutsideClick);
    };
  }, []);
  return (
    <>
      <div
        style={{
          display: "flex",
          padding: "0",
          position: "relative",
        }}
      >
        <div className=" w-full">
          <CommonLayout />
          <div
            className={styles.container1}
            style={{ width: !subCategory ? "80vw" : "100%" }}
          >
            <div className={styles1.top_content}>
              <div>
                <p className={styles1.p1}>
                  {itemDetails?.user?.first_name ||
                    heading ||
                    venderData?.first_name ||
                    "All Products"}
                  <span className={styles1.span1}>
                    {venderData &&
                      `${
                        venderData?.address === "null"
                          ? ""
                          : `(${venderData?.address})`
                      }`}
                  </span>
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ position: "relative", marginTop: "0.8rem" }}>
                    <div
                      className={styles1.border}
                      onClick={() => toggleSearch(!searchShowHide.show)}
                      style={{ display: "flex" }}
                    >
                      <p> Sort By : {searchShowHide.value} </p>
                      <RiArrowDropDownFill className="text-red-500 hover:text-white" />
                    </div>
                    <div
                      ref={searchRef}
                      className={
                        searchShowHide.show
                          ? [`${styles1.options} ${styles1.optionShow}`]
                          : [`${styles1.options} ${styles1.optionHide}`]
                      }
                    >
                      <div
                        onClick={() => {
                          toggleSearch(false);
                          setSearShowHide({ value: "Assending" });
                          fetchAllData("asc");
                        }}
                        className={styles.sortby}
                      >
                        Assending
                      </div>
                      <div
                        onClick={() => {
                          toggleSearch(false);
                          setSearShowHide({ value: "Decending" });
                          fetchAllData("desc");
                        }}
                        className={styles.sortby}
                      >
                        Decending
                      </div>
                    </div>
                  </div>     
                  <div className="mt-4">
                    <Dropdown
                      name="type"
                      value={businessType}
                      options={allBusinessTypeData?.data}
                      onChange={(e)=>setBusinessType(e.value)}
                      // required={true}
                      optionLabel={'name'} 
                      optionValue={"name"}
                      className="border border-[#e34e4e] hover:border-[#e34e4e]"
                    />
                  </div>          
                  <div className={styles1.border_search}>
                    <input
                      type="text"
                      style={{
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                      }}
                      onChange={handleItemSearchChange}
                      placeholder="Search"
                    />
                    <CiSearch size={"1.1rem"} />
                  </div>
                  <button
                    className={styles.allProductButton}
                    style={{ marginTop: "0.8rem" }}
                    onClick={() => {
                      navigate("/app/menu/item/");
                      id = null;
                      setPageNumber(2);
                      fetchAllData();
                      setVenderId(null);
                      setVenderData({
                        first_name: "All Products",
                        address: "null",
                      });
                      // fetchProducts();
                    }}
                  >
                    All Products
                  </button>
                </div>
              </div>

              <p
                className={styles1.p2_border}
                onClick={() => {
                  setChangeStore(true);
                  // setItemDetails(null);
                }}
              >
                Change Store
              </p>
            </div>
            <hr style={{ marginTop: "1.3rem" }} />
          {  businessType==="Ecommerce"?
                (
                <ProductsCard
                  allProduct={allItemProduct}
                  handleAllProductClicked={handleAllProductClicked}
                  handleLoadMore={handleLoadMore}
                  hasMore={hasMore}
                /> 
                ):
                <FoodCard
                // openProductDeletModal=
                handleProductClick={handleAllProductClicked}
                allItemProduct={allItemProduct}/>
          }
           
            
          </div>
        </div>
      </div>
      {changeStore && (
        <CategoryModal
          setChangeStore={setChangeStore}
          getAllVendorCategory={getVenderItem}
        />
      )}
    </>
  );
};

export default Item;
